const AUTH = "/v1/admin-auth";
const AUTHENTICATED = '/v1/administrators';
const GIFTCARDS = '/v2/giftcards-admin';
const CRYPTO = '/v2/crypto-admin';
const WALLET = '/v1/wallets/admin';
const USERSROUTE = '/v1/users/admin';
const PREFERENCES = '/v1/preferences';
const PROMO = '/v1/promo';
const BONUS = '/v1/promo/bonus'

// ==================== AUTHENTICATION ENDPOINT ================
export const LOGIN = `${AUTH}/login`;
export const RECOVER = `${AUTH}/recover-account`;
export const RESET = `${AUTH}/reset-password-admin`;
export const GENERATE_2FA = `${AUTH}/generate`;
export const VERIFY_2FA = `${AUTH}/verify`;
export const PUSHNOTIFICATIONTOKEN = `/auth/admin/push-notification-token`;

// ================== PERMISSIONS ENDPOINT ===================
export const PERMISSIONS = `${AUTHENTICATED}/permissions`;

// ================ TEAM ENDPOINT ================
export const TEAM = `${AUTHENTICATED}/departments`

// ================ ADMIN MANAGER ENDPOINT =============
export const ADMIN = `${AUTHENTICATED}/admins`;
export const AUDITS = `${AUTHENTICATED}/audit-logs`
export const PROFILE = `${AUTHENTICATED}/profile`;
export const CHANGEPASSWORD = `${AUTHENTICATED}/passwords`
export const CHANGEPIN = `${AUTHENTICATED}/pin`
export const RETRIEVE_PIN = `${AUTHENTICATED}/pin-status`
export const RESET_ADMIN_PIN = `${AUTHENTICATED}/admins/reset_pin`

// =================== LOAD COUNTRIES =============
export const COUNTRIES = '/v1/preferences/countries'

// =================== GIFTCARDS ENDPOINT  =============
export const STORES = `${GIFTCARDS}/stores`
export const CATEGORIES = `${GIFTCARDS}/categories`
export const TRADE = `${GIFTCARDS}/trades`
export const STOREGIFTCARD = `${GIFTCARDS}/cards`
export const GIFTCARD_TRADES_SUMMARY = `${GIFTCARDS}/dashboard`
export const GIFTCARD_INCOME_OUTCOME = `${GIFTCARDS}/revenue`
export const TOP_TRADERS = `${GIFTCARDS}/top-traders`
export const TOP_CARDS = `${GIFTCARDS}/top-cards`
export const GIFTCARD_TERMS = `${GIFTCARDS}/terms`
export const GIFTCARD_STORES = `${GIFTCARDS}/card/stores`
export const VENDORS = `${GIFTCARDS}/vendors`

//==================== CRYPTO ENDPOINT  =====================

export const GET_ALL_COINS = `${CRYPTO}/get-coins`
export const UPDATE_INDIVIDUAL_COIN = `${CRYPTO}/update-coin`
export const UPDATE_COIN_RATE = `${CRYPTO}/update-coin-rate`
export const ADD_COIN_RATE = `${CRYPTO}/add-new-coin-rate`
export const RETRIEVE_COIN_TRADES = `${CRYPTO}/trades`
export const TRADE_ACTION = `${CRYPTO}/trades/close`
export const GET_SETTINGS = `${CRYPTO}/get-approval-condition`
export const SET_SETTINGS = `${CRYPTO}/set-approval-condition`
export const TRADE_SUM = `${CRYPTO}/trade-sums`
export const COIN_STATS = `${CRYPTO}/get-coins-stats`
export const DELETE_COIN_RATE = `${CRYPTO}/delete-coin-rate`


//=========================== end crypto endpoint =================//

// =========== WALLET TRANSACTIONS ENDPOINT =======
export const WALLETTRANSACTION = `${WALLET}/transactions`
export const TRANSACTIONREVERSAL = `${WALLET}/reverse-transaction`
export const WITHDRAWALTRANSACTION = `${WALLET}/withdrawals`
export const BLOCKWALLET = `${WALLET}/access/block`
export const UNBLOCKWALLET = `${WALLET}/access/unblock`

// =========== USERS MANAGEMENT ENDPOINT ===========
export const USERS = `${USERSROUTE}/list-without-details`
export const USERDETAILS = `${USERSROUTE}/view`
export const VIEWUSERTRANSACTION = `${USERSROUTE}/transactions`
export const VIEWUSERTRADES = `${USERSROUTE}/trades`
export const SUSPENDUSER = `${USERSROUTE}/access/suspend`
export const ACTIVATEUSER = `${USERSROUTE}/access/activate`
export const USERDASHBOARD = `${USERSROUTE}/users_dashboard`
export const TOP_transactionS = `${USERSROUTE}/transcations`
export const TRANSACTION_COUNT = `${USERSROUTE}/count`

// =========== APP CONTROLLER ENDPOINT ===========
export const APPSETTINGS = `${PREFERENCES}/settings`
export const APPNOTIFICATIONS = `/v1/notifications`
export const COINRATES = `${PREFERENCES}/settings/dollar-rate`


//=========== PROMO TUTORIALS AND RANKING ENDPOINTS ==========

export const COUPOUNS = `${PROMO}/coupon`
export const TUTORIALS = `${PROMO}/tutorials`
export const HOTTEST = `${PROMO}/hottest`
export const CRYPTO_TRADERS = `${PROMO}/trades/crypto`;
export const GIFTCARD_TRADERS = `${PROMO}/trades/giftcard`
export const TOP_CRYPTO = `${PROMO}/admin/topten/crypto`
export const TOP_GIFTCARD = `${PROMO}/admin/topten/giftcard`
export const REWARD_PAY = `${PROMO}/reward/pay`
export const GET_PROMOS = `${PROMO}/promo_code`
export const GET_COUPONS = `${PROMO}/admin/coupon`
export const COUPON_USERS = `${PROMO}/coupon_users`
//============ banner endpoints ================================

export const CREATE_BANNER = `${AUTHENTICATED}/upload-banner`
export const ALL_BANNER = `${AUTHENTICATED}/admin/get-banner-images`
export const DELETE_BANNER = `${AUTHENTICATED}/delete-banner-images`
export const  TOOGLE_BANNER = `${AUTHENTICATED}/toggle-banner-visibility`
export const EDIT_BANNER = `${AUTHENTICATED}/update-banner-images`

//============ BONUS ENDPOINTS ====================================

export const RETRIEVE_USER_DETAILS = `${BONUS}/get-users-by-username`
export const UPLOAD_BONUSES = `${BONUS}/create-bulk`
export const GET_BONUS =`${BONUS}/all`
